import { CSSProperties, FunctionComponent, useState } from 'react';
import { ApiResponseError, getIsApiResponseError } from '../api/rest';

type ApiErrorMessageProps = {
  error?: Error | ApiResponseError;
};

const ApiErrorMessage: FunctionComponent<ApiErrorMessageProps> = ({
  error,
}) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!error) {
    return null;
  }

  return (
    <div className="error mb-[20px] rounded-lg bg-red-100 p-[10px]">
      {error.message}
      {showDetails ? (
        <>
          {error.stack ? (
            <div className="pt-[20px] text-[12px]" style={STYLE_BREAK_WORD}>
              {getIsApiResponseError(error)
                ? getApiErrorDataString(error)
                : error.stack}
            </div>
          ) : null}
        </>
      ) : (
        <>
          {' '}
          (
          <a
            href="#"
            onClick={(evt) => {
              evt.preventDefault();
              setShowDetails(true);
            }}
          >
            show details
          </a>
          )
        </>
      )}
    </div>
  );
};

export default ApiErrorMessage;

const STYLE_BREAK_WORD: CSSProperties = { wordBreak: 'break-word' };

// TODO(DRY) - move these somewhere better for error handling

function getApiErrorDataString(err: ApiResponseError) {
  const { path, status, data } = err;
  return JSON.stringify({ path, status, data });
}

export const errorToString = (err: unknown) => {
  let msg = '';
  try {
    msg = `${(err as Error).message}`;
  } catch {}
  return msg || `${err}`;
};
